<!-- eslint-disable vue/multi-word-component-names -->
<script>
import SharedMixin from '@/Mixins/Shared';
import SharedHelper from '@/Helpers/Shared';
import AppPageContainer from '@/components/app/PageContainer.vue';
import AppDashboardCard from '@/components/app/dashboardCard.vue';
import StationTimesTable from '@/components/shared/timeReport/stationTimesTable.vue';
import AppDatePicker from '@/components/app/DatePicker.vue';
import ReportMixin from '@/Mixins/Report/ReportMixin';
import ReportTransform from '@/Mixins/Report/report.transform';
import AlertComponent from '@/components/AlertComponent.vue';
import ExcelHelper from '@/Helpers/Excel.generator.helper';

export default {
  mixins: [SharedMixin, SharedHelper, ReportMixin, ReportTransform, ExcelHelper],
  components: {
    AppPageContainer,
    AppDashboardCard,
    StationTimesTable,
    AppDatePicker,
    AlertComponent,
  },
  title: 'گزارشات زمان ها',
  inject: ['load'],
  data() {
    return {
      isFilterModalOpen: false,
      isSearch: false,
      dateParams: {
        fromDate: null,
        toDate: null,
      },
    };
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      // this.getAverageStationTimesReport(this.dateParams)
      this.getAllTimes();
    },
    setFilterModalOpen: function (value) {
      this.isFilterModalOpen = value;
    },
    filterData: function () {
      this.isFilterModalOpen = false;
      this.isSearch = true;
      this.getAllTimes();
    },
    removeFilters: function () {
      this.isSearch = false;
      const resetParams = {
        fromDate: null,
        toDate: null,
      };

      this.getAverageStationTimesReport(resetParams);
      this.getAverageTimesReport(resetParams);
    },
    getAllTimes: function () {
      this.getAverageStationTimesReport(this.dateParams);
      this.getAverageTimesReport(this.dateParams);
    },
  },
  watch: {},
};
</script>
<template>
  <app-page-container title="گزارش زمان ها" class="time-report-page">
    <template v-slot:header>
      <v-col cols="4" class="">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3 mr-n16"></v-text-field>
      </v-col>
      <v-col cols="1" class="mr-n3">
        <v-btn class="mx-2 mt-3" fab dark small @click="setFilterModalOpen(true)" color="darkColor" elevation="0">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="mr-n6 mt-6" v-if="isSearch">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1" class="mt-3" v-if="stationsAverageTimesExel?.length > 0">
        <v-btn @click="
          exportToExcel([...stationTimeHeaders, { title: 'پایگاه', value: 'station', }], [...stationsAverageTimesExel], 'title', `station-times-average_report_page_${page}`)
          " fab dark small color="darkColor" elevation="0">
          <v-icon dark>mdi-file-excel mdi-18px</v-icon>
        </v-btn>
      </v-col>

    </template>
    <template v-slot:body>
      <section class="body-container">
        <app-dashboard-card class="mx-2 mb-3">
          <v-row>
            <v-col v-for="{ id, title, time, fence, showTime } in allAverageTimes" :key="id" cols="2">
              <v-row>
                <v-col cols="12" class="each_time_title pb-0">
                  {{ title }}
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <div class="flex-gap-2">
                        <div>
                          <v-icon color="#212121">mdi-account mdi-20px</v-icon>
                        </div>
                        <div class="each_time_text">{{ time }}</div>
                      </div>
                    </v-col>
                    <v-col cols="12" v-if="showTime" :style="{ opacity: showTime ? 1 : 0.3 }">
                      <div class="flex-gap-2">
                        <v-icon dark color="darkColor">mdi-vector-square mdi-20px</v-icon>
                        <div class="primary-color each_time_text">
                          {{ fence || '-' }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </app-dashboard-card>
        <station-times-table :stations-average-times="stationsAverageTimes" :station-time-headers="stationTimeHeaders"
          :loading="loading.gettingStationsAverageTimes" />
      </section>
    </template>
    <template v-slot:append>
      <v-dialog v-model="isFilterModalOpen" width="360px">
        <v-card>
          <v-row no-gutters>
            <v-col cols="12" class="modal-header py-5">
              <v-row no-gutters>
                <v-spacer></v-spacer>
                <span class="modal-title-text text-center">فیلتر</span>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
          </v-row>
          <v-card-text class="mt-12">
            <app-date-picker inputID="fromDate" label="از تاریخ" class="mb-4" v-model="dateParams.fromDate" />
            <app-date-picker inputID="toDate" label="تا تاریخ" v-model="dateParams.toDate" />
          </v-card-text>
          <v-card-action>
            <v-row no-gutters class="pb-4 mx-4">
              <v-col>
                <v-btn dark rounded block color="darkColor" @click="filterData">جستجو</v-btn>
              </v-col>
              <v-col class="pr-4">
                <v-btn outlined dark block rounded color="darkColor" @click="setFilterModalOpen(false)">
                  انصراف
                </v-btn>
              </v-col>
            </v-row>
          </v-card-action>
        </v-card>
      </v-dialog>
      <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
        :snakIcon="snakIcon" />
    </template>
  </app-page-container>
</template>
<style lang="scss">
.time-report-page {
  .page-container-body {
    height: 90dvh;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
  }
}
</style>
<style scoped lang="css">
.body-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
  margin-left: 0 !important;
}
</style>
